import Storage from 'storage';

import CONFIG from 'config';
import { setUserCookie, deleteUserCookie } from 'utils/cookies';

import { AuthState, AuthAction } from './authReducer.types';

const authReducer = (state: AuthState, action: AuthAction) => {
  switch (action.type) {
    case 'set_user':
      Storage.store('user', action.payload.user);
      Storage.store('environment', action.payload.environment);

      const organisation =
        CONFIG.ORGANISATIONS[
          action.payload.environment as keyof typeof CONFIG.ORGANISATIONS
        ];

      if (organisation?.api_endpoint) {
        Storage.store('API_ENDPOINT', organisation.api_endpoint);
      }

      setUserCookie(action.payload.user.token, organisation?.auto_detect_host);

      return {
        user: action.payload.user,
        environment: action.payload.environment,
      };
    case 'remove_user':
      const currentEnv = Storage.get(
        'environment',
      ) as keyof typeof CONFIG.ORGANISATIONS;
      const host = CONFIG.ORGANISATIONS[currentEnv]?.auto_detect_host;

      Storage.remove('user');
      Storage.remove('API_ENDPOINT');
      Storage.remove('environment');

      deleteUserCookie(host);

      return { user: null, environment: null };
    case 'set_online':
      const newState = {
        ...state,
        user: {
          ...state.user,
          is_online: action.payload,
        },
      };
      Storage.store('user', newState.user);
      return newState;
    default:
      return state;
  }
};

export default authReducer;
